goog.provide("shadow.js.shim.module$src$svg$type$adset_channel$tiktok_svg$default");
shadow.js.shim.module$src$svg$type$adset_channel$tiktok_svg$default = shadow.js.shim.module$src$svg$type$adset_channel$tiktok_svg.default;
